<div id="dashboard-page" fxLayout="column">
  <gridster [options]="options" fxFlex class="dashboard-gridster">
    <gridster-item [item]="item" *ngFor="let item of dashboard" class="dashboard-gridster-item">
      <app-dashboard-card [title]="item.title">
        <div>Card Content Here</div>
      </app-dashboard-card>
    </gridster-item>
    <gridster-item [item]="assetsItem" class="dashboard-gridster-item">
      <app-dashboard-card [title]="assetsItem.title" [loading]="assetsItem.loading">
        <h1>{{ assetsItem.value }}</h1>
      </app-dashboard-card>
    </gridster-item>
    <gridster-item [item]="ammountItem" class="dashboard-gridster-item">
      <app-dashboard-card [title]="ammountItem.title" [loading]="ammountItem.loading">
        <h1>{{ ammountItem.value.ammount.toFixed(2) }} €</h1>
        <h1>{{ ammountItem.value.deprecationAmmount.toFixed(2) }} €</h1>
      </app-dashboard-card>
    </gridster-item>
    <gridster-item [item]="ammountByClassesItem" class="dashboard-gridster-item">
      <app-dashboard-card [title]="ammountByClassesItem.title" [loading]="ammountByClassesItem.loading">
        <canvas baseChart width="100%" height="100%"
          [datasets]="ammountByClassesItem.barChartData"
          [labels]="ammountByClassesItem.barChartLabels"
          [options]="ammountByClassesItem.barChartOptions"
          [plugins]="ammountByClassesItem.barChartPlugins"
          [legend]="ammountByClassesItem.barChartLegend"
          [type]="ammountByClassesItem.barChartType">
        </canvas>
      </app-dashboard-card>
    </gridster-item>
  </gridster>
</div>
